import RegisterVerify from './register-verify';

export default RegisterVerify;
